import { moduleMemoFactory } from '@cmctechnology/webinvest-module';

export interface IPassThroughIFrameProps {
  frameId?: string;
  url: string;
  sitePrefix: string;
  routePrefix: string;
}

export interface INavCanvasProps {
  tradingRoutePrefix: string;
  publicUrl: string;
}
export interface IDashboardProps {
  tradingRoutePrefix: string;
}
export interface ISalesforceChatAgentProps {
  marketing: boolean;
}

export const ModuleConfigs = {
  SalesforceChatAgent: {
    appName: 'webinvest-module-contact-us',
    moduleName: './SalesforceChatAgent'
  },
  ProExpiredModal: { appName: 'webinvest-module-client-profile', moduleName: './ProExpiredModal' },
  NavCanvas: { appName: 'webinvest-module-navigation', moduleName: './NavCanvas' },
  PassThroughIFrame: { appName: 'webinvest-module-pass-through', moduleName: './PassThrough' },
  Dashboard: { appName: 'webinvest-module-dashboard', moduleName: './Dashboard' },
  Watchlists: { appName: 'webinvest-module-watchlists', moduleName: './Watchlists' },
  ProfitLoss: { appName: 'webinvest-module-profit-loss', moduleName: './ProfitLoss' },
  ProfitLossAccBalance: { appName: 'webinvest-module-profit-loss', moduleName: './AccountBalancePnL' }
};

export const WelcomeTour = moduleMemoFactory({ appName: 'webinvest-module-client-profile', moduleName: './WelcomeTour' });
export const BanyanReports = moduleMemoFactory({ appName: 'webinvest-module-banyantree', moduleName: './BanyanReports' });
export const NavCanvas = moduleMemoFactory<React.PropsWithChildren<INavCanvasProps>>(ModuleConfigs.NavCanvas);

export const LoginManager = moduleMemoFactory({ appName: 'webinvest-module-login', moduleName: 'LoginManager' });

export const FGLoginManager = moduleMemoFactory({ appName: 'webinvest-module-login-fg', moduleName: './FGFlowManager' });
export const FGFlowChangePassword = moduleMemoFactory({ appName: 'webinvest-module-login-fg', moduleName: './FGFlowChangePassword' });
export const FGFlowChangeUsername = moduleMemoFactory({ appName: 'webinvest-module-login-fg', moduleName: './FGFlowChangeUsername' });
export const FGFlowEnableMfa = moduleMemoFactory({ appName: 'webinvest-module-login-fg', moduleName: './FGFlowEnableMfa' });
export const FGFlowDisableMfa = moduleMemoFactory({ appName: 'webinvest-module-login-fg', moduleName: './FGFlowDisableMfa' });
export const ProExpiredModal = moduleMemoFactory<{ showModal: boolean; onClose: () => void }>(ModuleConfigs.ProExpiredModal);

export const PassThroughIFrame = moduleMemoFactory<IPassThroughIFrameProps>(ModuleConfigs.PassThroughIFrame);

export const Dashboard = moduleMemoFactory<IDashboardProps>(ModuleConfigs.Dashboard);

export const SalesforceChatAgent = moduleMemoFactory<ISalesforceChatAgentProps>(ModuleConfigs.SalesforceChatAgent);

export const CloudAnalytics = moduleMemoFactory({ appName: 'webinvest-module-analytics', moduleName: './CloudAnalytics' });

export const AccountDetailsPage = moduleMemoFactory({ appName: 'webinvest-module-settings', moduleName: './AccountDetailsPage' });

export interface ISalesforceFormProps {
  pageName?: string;
  hostUrl?: string;
}

export const SfOmniForm = moduleMemoFactory<ISalesforceFormProps>({ appName: 'webinvest-module-salesforce-omni-page', moduleName: './SalesforceForm' });

export const PricingSubscription = moduleMemoFactory<IDashboardProps>({
  appName: 'webinvest-module-pricing-subscription',
  moduleName: './PricingSubscription'
});

export interface IGenericWidgetProps {
  isFullScreen?: boolean;
}

export interface IScreeningWidgetProps extends IGenericWidgetProps {
  id: string;
}

export const StockHeatMap = moduleMemoFactory<IGenericWidgetProps>({ appName: 'webinvest-module-generic-widget', moduleName: './StockHeatMap' });
export const EtfHeatMap = moduleMemoFactory<IGenericWidgetProps>({ appName: 'webinvest-module-generic-widget', moduleName: './EtfHeatMap' });
export const TipRanksNews = moduleMemoFactory<IGenericWidgetProps>({ appName: 'webinvest-module-generic-widget', moduleName: './TipRanksNews' });
export const TradingViewScreener = moduleMemoFactory<IScreeningWidgetProps>({
  appName: 'webinvest-module-generic-widget',
  moduleName: './TradingViewScreener'
});

export const TradingViewDisclaimer = moduleMemoFactory({
  appName: 'webinvest-module-generic-widget',
  moduleName: './TradingViewDisclaimer'
});
